import http from "./http";
let baseUrl = "/finance-web";

/**
 * 查询其他直接费列表
 * */
const queryOtherListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/middle/other/direct/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询措施费列表
 * */
const queryMeasureListService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/middle/other/measure/list", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 查询单条措施费列表
 * */
const queryMeasureDetailService = (params) => {
    return new Promise((resolve, reject) => {
        http.get("/contract-web/middle/other/measure/detail", params, true).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 更新其他直接费（仅其他直接费）
 * */
const saveOtherBatchService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/middle/other/updateProjectOtherFee", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 批量更新其他直接费（仅其他直接费）
 * */
const saveMulOtherBatchService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/middle/other/batchUpdateProjectOtherFee", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 新增其他直接费工程量清单
 * */
const addOtherDataService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/middle/other/addProjectOtherDirectFee?projectId="+params.projectId, params.voList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 通过措施费页面的按钮新增细目（仅措施费）
 * */
const addItemsService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/middle/other/addProjectOtherDirectFee?projectId="+params.projectId, params.voList, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 通过列表里的按钮新增细目（其他直接费/措施费）
 * */
const saveBatchService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/middle/other/addProjectOtherFeeItems", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 通过措施费页面的按钮新增细目（仅措施费）
 * */
const addDetailsService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/middle/other/addProjectOtherFeeItemsInit", params).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 删除其他直接费工程量清单
 * */
const deleteOtherItemsService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete("/contract-web/middle/other/delProjectOtherDirectFee", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}
/**
 * 删除细目（其他直接费/措施费）
 * */
const deleteItemsService = (params) => {
    return new Promise((resolve, reject) => {
        http.delete("/contract-web//middle/other/deleteProjectOtherFeeItems", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 导出其他直接费
 * */
const exportFeesService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web/middle/other/exportProjectOtherDirectFee", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}

/**
 * 导出措施费
 * */
const exportMeasureService = (params) => {
    return new Promise((resolve, reject) => {
        http.post("/contract-web//middle/other/exportProjectOtherMeasureFee", params, false).then(result => {
            resolve(result);
        }).catch(error => {
            reject(error);
        })
    });
}


export {
    exportMeasureService,
    queryOtherListService,
    queryMeasureListService,
    queryMeasureDetailService,
    saveOtherBatchService,
    saveMulOtherBatchService,
    addOtherDataService,
    saveBatchService,
    addDetailsService,
    addItemsService,
    deleteOtherItemsService,
    exportFeesService,
    deleteItemsService
}
